/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SearchRebalancingNodeFilterValuesResponse } from '../models';
// @ts-ignore
import type { SearchRebalancingNodeFiltersResponse } from '../models';
// @ts-ignore
import type { SearchRebalancingNodesRequest } from '../models';
// @ts-ignore
import type { SearchRebalancingNodesResponse } from '../models';
// @ts-ignore
import type { SearchRebalancingWorkloadsRequest } from '../models';
// @ts-ignore
import type { SearchRebalancingWorkloadsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * RebalancingConfigAPIApi - axios parameter creator
 * @export
 */
export const RebalancingConfigAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Searches available values for a specific node filter type.  Supports pagination and keyword search for typeahead.
         * @summary Search values for a node filter type.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum} [field] The filter type to retrieve values for.
         * @param {string} [keyword] Keyword to search/filter the values (for typeahead).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodeFilterValues: async (organizationId: string, clusterId: string, field?: RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodeFilterValues', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodeFilterValues', 'clusterId', clusterId)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/rebalancing-configurations:searchNodeFilterValues`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches available node filter types for this cluster.
         * @summary Search available node filter types.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodeFilters: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodeFilters', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodeFilters', 'clusterId', clusterId)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/rebalancing-configurations:searchNodeFilters`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches cluster nodes for the rebalancing configuration view.
         * @summary Search cluster nodes for rebalancing configuration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SearchRebalancingNodesRequest} searchRebalancingNodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodes: async (organizationId: string, clusterId: string, searchRebalancingNodesRequest: SearchRebalancingNodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodes', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodes', 'clusterId', clusterId)
            // verify required parameter 'searchRebalancingNodesRequest' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingNodes', 'searchRebalancingNodesRequest', searchRebalancingNodesRequest)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/rebalancing-configurations:searchNodes`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchRebalancingNodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches cluster workloads for the rebalancing configuration view.
         * @summary Search cluster workloads for rebalancing configuration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SearchRebalancingWorkloadsRequest} searchRebalancingWorkloadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingWorkloads: async (organizationId: string, clusterId: string, searchRebalancingWorkloadsRequest: SearchRebalancingWorkloadsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingWorkloads', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingWorkloads', 'clusterId', clusterId)
            // verify required parameter 'searchRebalancingWorkloadsRequest' is not null or undefined
            assertParamExists('rebalancingConfigAPISearchRebalancingWorkloads', 'searchRebalancingWorkloadsRequest', searchRebalancingWorkloadsRequest)
            const localVarPath = `/cluster-autoscaler/v1/organizations/{organizationId}/clusters/{clusterId}/rebalancing-configurations:searchWorkloads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchRebalancingWorkloadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RebalancingConfigAPIApi - functional programming interface
 * @export
 */
export const RebalancingConfigAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RebalancingConfigAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Searches available values for a specific node filter type.  Supports pagination and keyword search for typeahead.
         * @summary Search values for a node filter type.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum} [field] The filter type to retrieve values for.
         * @param {string} [keyword] Keyword to search/filter the values (for typeahead).
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingConfigAPISearchRebalancingNodeFilterValues(organizationId: string, clusterId: string, field?: RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRebalancingNodeFilterValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingConfigAPISearchRebalancingNodeFilterValues(organizationId, clusterId, field, keyword, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingConfigAPIApi.rebalancingConfigAPISearchRebalancingNodeFilterValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches available node filter types for this cluster.
         * @summary Search available node filter types.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingConfigAPISearchRebalancingNodeFilters(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRebalancingNodeFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingConfigAPISearchRebalancingNodeFilters(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingConfigAPIApi.rebalancingConfigAPISearchRebalancingNodeFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches cluster nodes for the rebalancing configuration view.
         * @summary Search cluster nodes for rebalancing configuration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SearchRebalancingNodesRequest} searchRebalancingNodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingConfigAPISearchRebalancingNodes(organizationId: string, clusterId: string, searchRebalancingNodesRequest: SearchRebalancingNodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRebalancingNodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingConfigAPISearchRebalancingNodes(organizationId, clusterId, searchRebalancingNodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingConfigAPIApi.rebalancingConfigAPISearchRebalancingNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches cluster workloads for the rebalancing configuration view.
         * @summary Search cluster workloads for rebalancing configuration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {SearchRebalancingWorkloadsRequest} searchRebalancingWorkloadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingConfigAPISearchRebalancingWorkloads(organizationId: string, clusterId: string, searchRebalancingWorkloadsRequest: SearchRebalancingWorkloadsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRebalancingWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingConfigAPISearchRebalancingWorkloads(organizationId, clusterId, searchRebalancingWorkloadsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingConfigAPIApi.rebalancingConfigAPISearchRebalancingWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RebalancingConfigAPIApi - factory interface
 * @export
 */
export const RebalancingConfigAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RebalancingConfigAPIApiFp(configuration)
    return {
        /**
         * Searches available values for a specific node filter type.  Supports pagination and keyword search for typeahead.
         * @summary Search values for a node filter type.
         * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodeFilterValues(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchRebalancingNodeFilterValuesResponse> {
            return localVarFp.rebalancingConfigAPISearchRebalancingNodeFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches available node filter types for this cluster.
         * @summary Search available node filter types.
         * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodeFilters(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchRebalancingNodeFiltersResponse> {
            return localVarFp.rebalancingConfigAPISearchRebalancingNodeFilters(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches cluster nodes for the rebalancing configuration view.
         * @summary Search cluster nodes for rebalancing configuration.
         * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingNodes(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchRebalancingNodesResponse> {
            return localVarFp.rebalancingConfigAPISearchRebalancingNodes(requestParameters.organizationId, requestParameters.clusterId, requestParameters.searchRebalancingNodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches cluster workloads for the rebalancing configuration view.
         * @summary Search cluster workloads for rebalancing configuration.
         * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingConfigAPISearchRebalancingWorkloads(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchRebalancingWorkloadsResponse> {
            return localVarFp.rebalancingConfigAPISearchRebalancingWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.searchRebalancingWorkloadsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rebalancingConfigAPISearchRebalancingNodeFilterValues operation in RebalancingConfigAPIApi.
 * @export
 * @interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest
 */
export interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly clusterId: string

    /**
     * The filter type to retrieve values for.
     * @type {'TYPE_UNSPECIFIED' | 'NAME' | 'CAST_NODE_ID' | 'STATUS' | 'RESOURCE_OFFERING' | 'LABEL' | 'NODE_TEMPLATE' | 'INSTANCE_TYPE' | 'AVAILABILITY_ZONE' | 'ADDED_BY' | 'REMOVAL_DISABLED' | 'UNSCHEDULABLE' | 'CONFIG' | 'CONFIG_VERSION' | 'OS'}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly field?: RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum

    /**
     * Keyword to search/filter the values (for typeahead).
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly keyword?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValues
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for rebalancingConfigAPISearchRebalancingNodeFilters operation in RebalancingConfigAPIApi.
 * @export
 * @interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest
 */
export interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilters
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilters
     */
    readonly clusterId: string
}

/**
 * Request parameters for rebalancingConfigAPISearchRebalancingNodes operation in RebalancingConfigAPIApi.
 * @export
 * @interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest
 */
export interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodes
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodes
     */
    readonly clusterId: string

    /**
     * 
     * @type {SearchRebalancingNodesRequest}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodes
     */
    readonly searchRebalancingNodesRequest: SearchRebalancingNodesRequest
}

/**
 * Request parameters for rebalancingConfigAPISearchRebalancingWorkloads operation in RebalancingConfigAPIApi.
 * @export
 * @interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest
 */
export interface RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloads
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloads
     */
    readonly clusterId: string

    /**
     * 
     * @type {SearchRebalancingWorkloadsRequest}
     * @memberof RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloads
     */
    readonly searchRebalancingWorkloadsRequest: SearchRebalancingWorkloadsRequest
}

/**
 * RebalancingConfigAPIApi - object-oriented interface
 * @export
 * @class RebalancingConfigAPIApi
 * @extends {BaseAPI}
 */
export class RebalancingConfigAPIApi extends BaseAPI {
    /**
     * Searches available values for a specific node filter type.  Supports pagination and keyword search for typeahead.
     * @summary Search values for a node filter type.
     * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingConfigAPIApi
     */
    public rebalancingConfigAPISearchRebalancingNodeFilterValues(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFilterValuesRequest, options?: RawAxiosRequestConfig) {
        return RebalancingConfigAPIApiFp(this.configuration).rebalancingConfigAPISearchRebalancingNodeFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches available node filter types for this cluster.
     * @summary Search available node filter types.
     * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingConfigAPIApi
     */
    public rebalancingConfigAPISearchRebalancingNodeFilters(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodeFiltersRequest, options?: RawAxiosRequestConfig) {
        return RebalancingConfigAPIApiFp(this.configuration).rebalancingConfigAPISearchRebalancingNodeFilters(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches cluster nodes for the rebalancing configuration view.
     * @summary Search cluster nodes for rebalancing configuration.
     * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingConfigAPIApi
     */
    public rebalancingConfigAPISearchRebalancingNodes(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingNodesRequest, options?: RawAxiosRequestConfig) {
        return RebalancingConfigAPIApiFp(this.configuration).rebalancingConfigAPISearchRebalancingNodes(requestParameters.organizationId, requestParameters.clusterId, requestParameters.searchRebalancingNodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches cluster workloads for the rebalancing configuration view.
     * @summary Search cluster workloads for rebalancing configuration.
     * @param {RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingConfigAPIApi
     */
    public rebalancingConfigAPISearchRebalancingWorkloads(requestParameters: RebalancingConfigAPIApiRebalancingConfigAPISearchRebalancingWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return RebalancingConfigAPIApiFp(this.configuration).rebalancingConfigAPISearchRebalancingWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.searchRebalancingWorkloadsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum = {
    TYPE_UNSPECIFIED: 'TYPE_UNSPECIFIED',
    NAME: 'NAME',
    CAST_NODE_ID: 'CAST_NODE_ID',
    STATUS: 'STATUS',
    RESOURCE_OFFERING: 'RESOURCE_OFFERING',
    LABEL: 'LABEL',
    NODE_TEMPLATE: 'NODE_TEMPLATE',
    INSTANCE_TYPE: 'INSTANCE_TYPE',
    AVAILABILITY_ZONE: 'AVAILABILITY_ZONE',
    ADDED_BY: 'ADDED_BY',
    REMOVAL_DISABLED: 'REMOVAL_DISABLED',
    UNSCHEDULABLE: 'UNSCHEDULABLE',
    CONFIG: 'CONFIG',
    CONFIG_VERSION: 'CONFIG_VERSION',
    OS: 'OS'
} as const;
export type RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum = typeof RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum[keyof typeof RebalancingConfigAPISearchRebalancingNodeFilterValuesFieldEnum];
